import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import JBImage from 'components/essentials/JBImage';
import useFixedWidthContainerSizeProps from 'hooks/useFixedWidthContainerSizeProps';
import MobileAndTabletOnly from 'components/consumer/MobileAndTabletOnly';
import DesktopOnly from 'components/consumer/DesktopOnly';
import PDPDimensionShotViewer from '../PDPDimensionShotViewer';

// Cylindo dimension shots when the product has them, else the static image
const PDPDimensionsImage = t0 => {
  const $ = _c(28);
  const {
    dimensionsDesktopImage,
    dimensionsMobileImage,
    onImageClick,
    isSidebarContent: t1,
    hasCylindoDimensionShots: t2,
    dimensionShotUrls: t3,
    currentDimensionShot,
    selectedDimensionShotIndex: t4,
    setSelectedDimensionShotIndex
  } = t0;
  const isSidebarContent = t1 === undefined ? false : t1;
  const hasCylindoDimensionShots = t2 === undefined ? false : t2;
  let t5;
  if ($[0] !== t3) {
    t5 = t3 === undefined ? [] : t3;
    $[0] = t3;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const dimensionShotUrls = t5;
  const selectedDimensionShotIndex = t4 === undefined ? 0 : t4;
  const desktopImageFullWidthProps = useFixedWidthContainerSizeProps();
  let t6;
  if ($[2] !== desktopImageFullWidthProps || $[3] !== isSidebarContent) {
    t6 = isSidebarContent ? {
      sizes: "30vw"
    } : desktopImageFullWidthProps;
    $[2] = desktopImageFullWidthProps;
    $[3] = isSidebarContent;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const desktopImageProps = t6;
  let t7;
  if ($[5] !== currentDimensionShot || $[6] !== dimensionShotUrls || $[7] !== dimensionsMobileImage || $[8] !== hasCylindoDimensionShots || $[9] !== selectedDimensionShotIndex || $[10] !== setSelectedDimensionShotIndex) {
    t7 = hasCylindoDimensionShots && currentDimensionShot ? <PDPDimensionShotViewer dimensionShots={dimensionShotUrls} selectedDimensionShotIndex={selectedDimensionShotIndex} onIndexChange={setSelectedDimensionShotIndex} className="w-full mt-6 mx-0 mb-4 lg:m-0 lg:hidden aspect-[1/1]" sizes="100vw" height="900" width="900" /> : dimensionsMobileImage && <JBImage src={dimensionsMobileImage} sizes="100vw" height="900" width="900" className="w-full mt-6 mx-0 mb-4 lg:m-0 lg:hidden" />;
    $[5] = currentDimensionShot;
    $[6] = dimensionShotUrls;
    $[7] = dimensionsMobileImage;
    $[8] = hasCylindoDimensionShots;
    $[9] = selectedDimensionShotIndex;
    $[10] = setSelectedDimensionShotIndex;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <MobileAndTabletOnly>{t7}</MobileAndTabletOnly>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== currentDimensionShot || $[15] !== desktopImageProps || $[16] !== dimensionShotUrls || $[17] !== dimensionsDesktopImage || $[18] !== hasCylindoDimensionShots || $[19] !== onImageClick || $[20] !== selectedDimensionShotIndex || $[21] !== setSelectedDimensionShotIndex) {
    t9 = hasCylindoDimensionShots && currentDimensionShot ? <PDPDimensionShotViewer dimensionShots={dimensionShotUrls} selectedDimensionShotIndex={selectedDimensionShotIndex} onIndexChange={setSelectedDimensionShotIndex} className={classNames("w-full mt-6 mx-0 mb-4 lg:m-0 max-[1023px]:hidden aspect-[4/3]", {
      "hover:cursor-target": onImageClick
    })} onClick={onImageClick} {...desktopImageProps} /> : dimensionsDesktopImage && <JBImage src={dimensionsDesktopImage} onClick={onImageClick} {...desktopImageProps} className={classNames("w-full mt-6 mx-0 mb-4 lg:m-0 max-[1023px]:hidden", {
      "hover:cursor-target": onImageClick
    })} />;
    $[14] = currentDimensionShot;
    $[15] = desktopImageProps;
    $[16] = dimensionShotUrls;
    $[17] = dimensionsDesktopImage;
    $[18] = hasCylindoDimensionShots;
    $[19] = onImageClick;
    $[20] = selectedDimensionShotIndex;
    $[21] = setSelectedDimensionShotIndex;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t9) {
    t10 = <DesktopOnly>{t9}</DesktopOnly>;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t8) {
    t11 = <>{t8}{t10}</>;
    $[25] = t10;
    $[26] = t8;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
};
PDPDimensionsImage.propTypes = {
  dimensionsDesktopImage: PropTypes.string,
  dimensionsMobileImage: PropTypes.string,
  isSidebarContent: PropTypes.bool,
  onImageClick: PropTypes.func,
  hasCylindoDimensionShots: PropTypes.bool,
  dimensionShotUrls: PropTypes.arrayOf(PropTypes.object),
  currentDimensionShot: PropTypes.shape({
    src: PropTypes.string.isRequired,
    dimensionCode: PropTypes.string.isRequired
  }),
  selectedDimensionShotIndex: PropTypes.number,
  setSelectedDimensionShotIndex: PropTypes.func
};
export default PDPDimensionsImage;